import React from "react"
import * as styles from "./section-top.module.scss"
import { useBreakpoint } from "gatsby-plugin-breakpoints"

import DemoButton from "./button-demo"

import ParkDirectLogo from "../images/logo-park-direct.svg";
import CheckIcon from "../images/icon-check.png";
import TopTitle from "../images/title-top.svg"

/**
 * ファーストビューで表示されるエリア
 */
export default function Top() {
  return (
    <div className={styles.container}>
      <div className={styles.contents}>
        <div className={styles.img_logo}>
            <img src={ParkDirectLogo} alt="Park Direct for Business" />
        </div>
        <div className={styles.phrase}>
            <div className={styles.catchphrase}>
                <img src={TopTitle} alt="法人車両の駐車場管理をオンラインでもっとラクに" />
                <ul className={styles.description}>
                    <li><img src={CheckIcon} alt="チェックアイコン" /><p>駐車場探し〜契約までオンラインで完結</p></li>
                    <li><img src={CheckIcon} alt="チェックアイコン" /><p>社内の契約情報・支払い先を一元管理</p></li>
                </ul>
            </div>
        </div>
        <div className={styles.buttons}>
          <DemoButton />
        </div>
      </div>
      <div className={styles.background} />
    </div>
  )
}
